export function setUtmDataFromQS(){
    let searchParams = new URLSearchParams(window.location.search);
    let utmData = {
        Source: searchParams.has('utm_source') ? searchParams.get('utm_source') : null,
        Medium: searchParams.has('utm_medium') ? searchParams.get('utm_medium') : null,
        Campaign: searchParams.has('utm_campaign') ? searchParams.get('utm_campaign') : null,
        Term: searchParams.has('utm_term') ? searchParams.get('utm_term') : null,
        Content: searchParams.has('utm_content') ? searchParams.get('utm_content') : null,
    };
    try { localStorage.setItem("utm_data", JSON.stringify(utmData));} catch (ex) {}
    return utmData;
}

export function getUtmData(){
    let data = {};
    try{
        let utmData = window.localStorage.getItem('utm_data');
        if( utmData ){
            utmData = JSON.parse(utmData);
            data.UtmSource = utmData.Source;
            data.UtmMedium = utmData.Medium;
            data.UtmCampaign = utmData.Campaign;
            data.UtmTerm = utmData.Term;
            data.UtmContent = utmData.Content;
        }
    }catch(err){
        return null;
    }
    return data;
}